<template>
  <div>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" sm="6">
          <v-card>
            <div class="mb-3">
              <v-card>
                <div class="pa-3">
                  <div class="pa-3 text-center">
                    <span>Your account configuration is not yet complete.</span>
                  </div>
                </div>
              </v-card>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'ErrorAccountConfiguration',
  data: () => {
    return {};
  },
};
</script>